import React from 'react';
import {svgIconWrapper} from '../svg-icon-wrapper';
import HourglassStart from './icon-hourglass-start.svg';

function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <HourglassStart {...validProps} />;
}
SvgComponent.iconName = 'hourglassStart';

export const HourglassStartIcon = svgIconWrapper(SvgComponent);
